import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

export class ValidaDocumento {
  validaCPF_CNPJ(CPF_CNPJ)  {
    if (CPF_CNPJ) {
      const strCPF_CNPJ = CPF_CNPJ.replace(/\D/g, '');
      if (strCPF_CNPJ.length === 11) {
        return this.validaCPF(strCPF_CNPJ);
      } else if (strCPF_CNPJ.length === 14) {
        return this.validaCNPJ(strCPF_CNPJ);
      } else if (strCPF_CNPJ.length > 0) {
        return false;
      } return true;
    } return false;
  }

  validaCPF(strCPF) {
    let Soma;
    let Resto;
    Soma = 0;
    if (strCPF === '00000000000') { return false; }

    for (let i = 1; i <= 9; i++) { Soma = Soma + parseInt(strCPF.substring(i - 1, i), 10) * (11 - i); }
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) { Resto = 0; }
    if (Resto !== parseInt(strCPF.substring(9, 10), 10)) { return false; }

    Soma = 0;
    for (let i = 1; i <= 10; i++) { Soma = Soma + parseInt(strCPF.substring(i - 1, i), 10) * (12 - i); }
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) { Resto = 0; }
    if (Resto !== parseInt(strCPF.substring(10, 11), 10)) { return false; }
    return true;
  }

  validaCNPJ(cnpj) {

    if (cnpj.length !== 14) {
      return false;
    }

    // Elimina CNPJs invalidos conhecidos
    if (cnpj === '00000000000000' ||
      cnpj === '11111111111111' ||
      cnpj === '22222222222222' ||
      cnpj === '33333333333333' ||
      cnpj === '44444444444444' ||
      cnpj === '55555555555555' ||
      cnpj === '66666666666666' ||
      cnpj === '77777777777777' ||
      cnpj === '88888888888888' ||
      cnpj === '99999999999999') {
      return false;
    }

    // Valida DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    const digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado !== parseInt(digitos.charAt(0), 10)) {
      return false;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado !== parseInt(digitos.charAt(1), 10)) {
      return false;
    }

    return true;
  }

  validaTelefone(telefone) {
      if(telefone){
      if(telefone.search(/[+]/g) == 0){
        const regExInternacional = /\+\d+/g;
        const validacao = regExInternacional.test(telefone)
        if (telefone !== '' && !validacao) {
          return false;
        }
        return true;
      }
      const regExp = /(\(\d{2}\) \d{4,5}\-\d{4})/g;
      const validaTelefone = regExp.test(telefone);
      if (telefone !== '' && !validaTelefone) {
        return false;
      }
    return true;
  }
  return false;
  }

  validaCelular(celular) {
    if(celular){
    if(celular.search(/[+]/g) == 0){
    const regExInternacional = /\+\d+/g;
    const validacao = regExInternacional.test(celular)
    if (celular !== '' && !validacao) {
      return false;
    }

    return true;
    }
    const regExp = /(\(\d{2}\) \d{4,5}\-\d{4})/g;
    const validaCelular = regExp.test(celular);
    if (celular !== '' && !validaCelular) {
      return false;
    }
    return true;
  }
  return false;
  }

  validaEmail(email) {
    if(email){
    const regExp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    const validaEmail = regExp.test(email);
    if (email !== '' && !validaEmail) {
      return false;
    }
    return true;
  }
  return false;
}
}
